import React from "react";
import MobileLayout from "../../Shared/MobileLayout";
import MobileNotice from "../../Shared/MobileNotice";
import OriginalComponentImpl from "../../../Pages/PageUnderDevelopment";

const OriginalComponent = OriginalComponentImpl as unknown as React.ComponentType<any>;

interface Props {
  [key: string]: any;
}

const PageUnderDevelopmentMobile: React.FC<Props> = (props) => {
  return (
    <MobileLayout title="PageUnderDevelopment">
      <MobileNotice page="PageUnderDevelopment" />
      <OriginalComponent {...props} />
    </MobileLayout>
  );
};

export default PageUnderDevelopmentMobile;